export const scPlanListPc = [
  { label: "报名阶段", value: 1, image: "pc/scPlan/1.png" },
  { label: "积分赛", value: 2, image: "pc/scPlan/2.png" },
  { label: "淘汰赛", value: 3, image: "pc/scPlan/3.png" },
  { label: "冠军赛", value: 4, image: "pc/scPlan/4.png" },
  { label: "总决赛", value: 5, image: "pc/scPlan/5.png" },
]

export const scPlanListM = [
  { label: "报名阶段", value: 1, image: "m/scPlan/1.png" },
  { label: "积分赛", value: 2, image: "m/scPlan/2.png" },
  { label: "淘汰赛", value: 3, image: "m/scPlan/3.png" },
  { label: "冠军赛", value: 4, image: "m/scPlan/4.png" },
  { label: "总决赛", value: 5, image: "m/scPlan/5.png" },
]

export const informationDateList = [
  {
    id: 1,
    name: "报名阶段",
    list: [
      { name: "报名<br />开启", date: "6月8日" },
      { name: "报名<br />截止", date: "6月14日" },
      { name: "战队<br />锁定", date: "6月15日" },
    ],
  },
  {
    id: 2,
    name: "积分赛",
    list: [
      { name: "第一场", date: "6月16日", hour: "21:30" },
      { name: "第二场", date: "6月17日", hour: "21:30" },
      { name: "第三场", date: "6月18日", hour: "21:30" },
    ],
  },
  {
    id: 3,
    name: "淘汰赛",
    list: [
      { name: "第一轮<br />初赛", date: "6月22日", hour: "13:00" },
      { name: "第一轮<br />复活赛", date: "6月22日", hour: "17:30" },
      { name: "第二轮<br />初赛", date: "6月23日", hour: "13:00" },
      { name: "第二轮<br />复活赛", date: "6月23日", hour: "17:30" },
    ],
  },
  {
    id: 4,
    name: "冠军赛",
    list: [
      { name: "64进16", date: "6月24-25日", hour: "20:00" },
      { name: "16进8", date: "6月28日", hour: "20:00" },
      { name: "8进4", date: "6月29日", hour: "13:00" },
      {
        name: "总决赛",
        date: "6月30日-7月7日",
        hour: "",
      },
    ],
  },
];

export const groupList = [
  { label: "无极组", value: 1, image: "m/wj.png" },
  { label: "纵横组 ", value: 2, image: "m/zh.png" },
  { label: "勇武组", value: 3, image: "m/yw.png" },
];

export const ruleInfoList = [
  {
    id: 1,
    name: "参赛要求",
    img: "",
    act_img: "",
    info: [
      {
        title: "参赛组别",
        text: (
          <div class="text">
            赛事分为3个组别，
            <span>勇武组(60-69级)、纵横组(70-89级) 无极组(90-109级)</span>
            。-符合参赛段位的玩家-报名后会自动进
            入对应的组别。不同组别等级的玩家不可加入同一战队。
          </div>
        ),
      },
    ],
  },
  {
    id: 2,
    name: "比赛规则",
    img: "",
    act_img: "",
    info: {},
  },
];

export const awardList = {
  three: {
    slidesPerView: 2,
    initialSlide: 1,
    spaceBetween: 10,
    key: "wj-three",
    type: "three-container",
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    spaceBetween: 30,
    key: "wj-other",
    type: "other-container",
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

export const honorsList = {
  slidesPerView: 2,
  initialSlide: 1,
  spaceBetween: -10,
  key: "honor-three",
  type: "honor-container",
  slideList: ["honor-1.png", "honor-2.png", "honor-3.png"],
};

export const ywAwardList = {
  three: {
    slidesPerView: 2,
    initialSlide: 2,
    spaceBetween: 10,
    key: "yw-three",
    type: "three-container",
    // slideList: ["ywAward-b.png", "ywAward-a.png", "ywAward-c.png"],
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    spaceBetween: 30,
    key: "yw-other",
    type: "other-container",
    // slideList: [
    //   "ywAward-4.png",
    //   "ywAward-5.png",
    //   "ywAward-1.png",
    //   "ywAward-2.png",
    //   "ywAward-3.png",
    // ],
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

export const zhAwardList = {
  three: {
    slidesPerView: 2,
    initialSlide: 1,
    spaceBetween: 10,
    key: "zh-three",
    type: "three-container",
    // slideList: ["zhAward-b.png", "zhAward-a.png", "zhAward-c.png"],
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    spaceBetween: 30,
    key: "zh-other",
    type: "other-container",
    // slideList: [
    //   "zhAward-4.png",
    //   "zhAward-5.png",
    //   "zhAward-1.png",
    //   "zhAward-2.png",
    //   "zhAward-3.png",
    // ],
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

export const awardListPC = {
  three: {
    slidesPerView: 2,
    initialSlide: 3,
    spaceBetween: 10,
    key: "wj-three-pc",
    type: "three-container",
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    spaceBetween: 30,
    key: "wj-other",
    type: "other-container",
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

// 赛事奖励 - 无极组
export const wjAwardListPC = {
  three: {
    slidesPerView: 2,
    initialSlide: 3,
    spaceBetween: 10,
    key: "wj-three-pc",
    type: "three-container",
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    spaceBetween: 30,
    key: "wj-other",
    type: "other-container",
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

// 赛事奖励 - 纵横组
export const zhAwardListPC = {
  three: {
    slidesPerView: 2,
    initialSlide: 3,
    key: "zh-three",
    type: "three-container",
    // slideList: ["zhAward-b.png", "zhAward-a.png", "zhAward-c.png"],
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    key: "zh-other",
    type: "other-container",
    // slideList: [
    //   "zhAward-4.png",
    //   "zhAward-5.png",
    //   "zhAward-1.png",
    //   "zhAward-2.png",
    //   "zhAward-3.png",
    // ],
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

// 赛事奖励 - 勇武组
export const ywAwardListPC = {
  three: {
    slidesPerView: 2,
    initialSlide: 3,
    key: "yw-three",
    type: "three-container",
    // slideList: ["ywAward-b.png", "ywAward-a.png", "ywAward-c.png"],
    slideList: ["award-b.png", "award-a.png", "award-c.png"],
  },
  other: {
    slidesPerView: 3,
    initialSlide: 2,
    key: "yw-other",
    type: "other-container",
    // slideList: [
    //   "ywAward-4.png",
    //   "ywAward-5.png",
    //   "ywAward-1.png",
    //   "ywAward-2.png",
    //   "ywAward-3.png",
    // ],
    slideList: [
      "award-4.png",
      "award-5.png",
      "award-1.png",
      "award-2.png",
      "award-3.png",
    ],
  },
};

export const entryRuleListOld = [
  {
    subTitle: "参赛组别",
    contentText: `
    <div class="text">参赛选手须达到一定等级+人物评分要求，才能获得参赛资格，并根据等级进入对应组别。</div>
    <div class="text">
    赛事分为3个组别，
    <span>勇武组（等级60-69级，人物评分4.5w+）、纵横组（等级70-89级,人物评分6.2w+）、无极组（等级90-109级,人物评分6.6w+）</span>
    。选手报名后，自动根据等级和人物评分进入对应组别。注意：不可跨组别等级组队。
  </div>
    `,
  },
  {
    subTitle: "参赛队伍人数",
    contentText: `
    <div class="text">
    每个队参赛人数至少5人，最多7人。到达报名时间截止后，队内参赛选手数量<5时，将视为默认弃权。
  </div>
    `,
  },
  {
    subTitle: "参赛职业要求",
    contentText: `
    <div class="text">
    每个队伍包括替补在内，同一职业最多两个。
  </div>
    `,
  },
  {
    subTitle: "参赛资格要求",
    contentText: `
    <div class="text">
    在满足参赛等级情况下，需要队长拥有1个星火邀约帖，才具备参赛资格。
  </div>
    `,
  },
  {
    subTitle: "注意事项",
    contentText: `
    <div class="text">
    玩家报名后可继续升级、转职等，但等级超过当前报名分组，则自动退队，且无法重新报名参加本届比赛。比赛当天不可转职。
  </div>
    `,
  },
];

// 参赛规则
const entryRuleText = [
  '星火联赛正式开幕!',
  '报名规则',
  '1、御灵师需组满同一等级段的5人队伍，队长拥有星火邀约帖即可报名',
  '2、报名后根据队伍成员等级进入不同等级组进行比赛',
  '3、队伍成员需要满足对应分组的评分要求，勇武组60~69级:40000评分，纵横组70~89级:60000评分，无极组≥90级:65000评分',
  '4、报名成功后，在队伍锁定前，可自由退队、邀请新成员，每个队伍可邀请2名御灵师作为替补，队伍最多7人，替补与其他成员享同样的参赛奖励(实物奖励需要参赛选手从积分赛开始到比赛结束至少上场3次才可获得，轮空则不算上场次数)',
  '5、队伍内最终上场参战的同职业御灵师不可超过2名',
  '6、报名后升级导致超出当前战队等级分组的御灵师将自动离队',
  '7、报名结束后，所有战队均有24小时的时间用于锁定战队，锁定后，战队无法进行人员变动',
  '8、战队锁定后，如果队伍内可参赛成员不足5人，所有人均可强制解散战队',
  '9、有比赛的战队，队内所有成员比赛当日，距离赛程开启6小时内无法转换门派。锁定报名后至个人赛程结束前，转换门派无冷却',
  '变身信物',
  '1、积分赛不扣除信物点数',
  '2、淘汰赛、冠军赛扣除每场10点信物点数',
  '排名说明',
  '1、积分赛阶段，按照积分排名，同积分优先根据队伍胜场数量排名',
  '2、同胜场数量按照队伍获胜场次平均回合数排名，回合数越短',
  '3、回合数若相同，则按照队伍内评分最高的5名御灵师评分总和排名，总评分越高，排名越靠前',
  '赛季养成相关说明',
  '1、天之将倾赛季新增的养成内容<天衍心诀>将正常生效，开启了天衍心诀的御灵师们可获得养成带来的属性、绝技、心悟、特技效果',
  '2、赛事场景中可切换自身流派，但是在比赛进入阵容锁定阶段后将无法切换流派哦~',
  '乘风服特殊说明',
  '1、乘风服选择了预突破的御灵师在报名成功后，会强制锁定在当前等级段(即使选择了预突破)，在赛程结束或失去下赛段参赛资格的次日5点，将可以突破等级。等级锁定区间可进行手动突破，但突破后队伍将解散',
  '2、乘风服的勇武组最高可上阵地阶妖灵',
  '3、乘风服的纵横组最高可上阵天阶妖灵',
  '4、星火联赛不区分乘风赛区，乘风服可参与每月定期开启的<烽火之战>争夺荣誉，欢迎御灵师们踊跃报名!',
  '赛事竞猜',
  '1、冠军赛阶段，每场比赛前均可进入竞猜界面领取竞猜币，用于下注竞猜',
  '2、比赛开始后，将无法继续下注哦',
  '星火联赛·年度总决赛说明',
  '1、2026年全年将根据第11届、第12届星火联赛，取"单届赛事最佳积分+多届鼓励积分"从高到低排序，选拔参赛队伍，成功入选的御灵师们将角逐星火年度线下总决赛的最终冠军。具体的积分细则请查看赛事中心-星火年度总决赛。',
  '2、年度总决赛预计在2026年11月开启，在12月26日举行线下赛。',
  '3、入围<星火联赛·年度总决赛>御灵师们将可额外获得星火年度选手专属礼盒等丰厚的游戏道具、实物奖励。同时，新增的<星火名人堂>荣誉系统将会收录总决赛选手的联赛战绩和成就，并赠予一系列的限定荣誉、外观内容权益，让总决赛选手成为官方认证的"头号玩家"。'	
]

export const entryRuleList = entryRuleText.map(item => {
  return {
    contentText: `<div class="text">${item}</div>`
  }
})

export const infoRulesListOld = [
  {
    id: 1,
    list: [
      {
        subTitle: "比赛赛制",
        contentText: `
        <div class="text">
        <div>1、积分赛比赛期间，所有队伍可以在比赛期间任何时间进场等待匹配开始。第一场在各自组别内进行自由匹配，后续匹配优先匹配同胜场/同积分的队伍。</div>
        <div>2、每天匹配战斗次数最多4场，积分赛期间最多参与8场比赛，且计入排名成绩，根据比赛胜场进行积分排名，积分排名前1~128的队伍进入星火赛区，129~256的队伍进入火种赛区。</div>
      </div>
        `,
      },
      {
        subTitle: "比赛规则",
        contentText: ` 
        <div class="text">
        <div><span>（1）积分规则： </span>胜者积3分，败者积1分，弃权积0分。</div>
        <div><span>（2）比赛回合数：</span>积分赛最多进行40回合，达到40回合后，比赛将会强制结算。</div>
      </div>`,
      },
      {
        subTitle: "同积分规则",
        contentText: ` 
        <div class="text">
        若出现同积分情况，判断规则如下
        <br />
  · 优先以积分赛胜场数排名，胜利场数越多，排名越靠前
  <br />
  · 若胜场数相同，则按战队战斗胜利消耗的总回合数排名，回合数越少，排名越靠前
  <br />
  · 若胜利回合数相同，则按照队伍内评分最高的5名玩家评分总和排名，队伍总评分越高，排名越靠前
      </div>`,
      },
    ],
  },
  {
    id: 2,
    list: [
      {
        subTitle: "比赛赛制",
        contentText: `
        <div class="text">
        淘汰赛分为两个阶段，第一阶段为256进128阶段，第二阶段为128进64阶段。两个阶段均采用双败淘汰赛制。每个阶段将划分为上下半区（即星火/火种赛区），星火赛区胜者直接晋级下一个阶段，星火赛区败者将于火种赛区胜者争取下一轮的晋级名额，火种赛区的败者直接淘汰。</div>
        `,
      },
      {
        subTitle: "比赛细则",
        contentText: `
        <div class="text">
        （1）赛区划分规则：
        <br />
        <br />
        ·第一阶段（256进128）--根据积分赛排名分为上下半区，积分赛排名1-128名的队伍进入上半区星火赛区，积分赛排名128-256名进入下半区火种赛区。
        <br />
        <br />
        ·第二阶段（128进64）--第一阶段上半区星火赛区的胜者进入第二阶段的星火赛区； 而下半区火种赛区将由第一阶段复活赛胜者组成。
      </div>
        `,
      },
    ],
  },
  {
    id: 3,
    list: [
      {
        subTitle: "比赛赛制",
        contentText: `
        <div class="text">
        冠军赛由64进16、16进4、总决赛3个阶段组成，64进16采用B01单败淘汰赛制，16进4和总决赛采用B03三局两胜赛制。胜者晋级、败者淘汰，最后决出本次赛事的冠军队伍。
      </div>
        `,
      },
      {
        subTitle: "比赛细则",
        contentText: `
        <div class="text">
        （1）匹配规则
        <br />
        · 64进16阶段，16进4阶段以及总决赛阶段，均进行随机匹配。 
      </div>
        `,
      },
    ],
  },
];
// 比赛规则
export const raceRulesList = [
  {
    id: 1,
    list: [
      {
        contentText: `
          <div class="text">
            ①报名期（2月27日~3月6日），3月7日锁定战队
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
           ②积分赛（3月8日~3月10日）
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            积分赛通过对战结果计分，每场获胜得3分，失败得1分，弃权不得分。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            积分赛前256名即可晋级淘汰赛。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            积分赛阶段，按照积分排名，同积分优先根据队伍胜场数量排名、同胜场数量按照队伍获胜场次平均回合数排名，回合数越短越靠前、回合数若相同，则按照队伍内评分最高的5名御灵师评分总和排名，总评分越高，排名越靠前。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            积分赛每场比赛40回合后会强制结算。
          </div>
        `
      }
    ],
  },
  {
    id: 2,
    list: [
      {
        contentText: `
          <div class="text">
            1、淘汰赛每轮共1场，胜利即可晋级下一轮。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            2、淘汰赛单场战斗最大60回合或80分钟，超出即会强制结算所有未结束的战斗。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            3、淘汰赛在入场开启10分钟后还未入场的队伍，默认弃权判负，对战双方全部弃权的，积分赛成绩排名更高的队伍判胜。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            4、淘汰赛每场战斗扣除10点变身信物点数。
          </div>
          <br>
          <p class="title">星光赛区说明</p>
          <div class="text">
            1、星光赛区第一轮胜利后可直接参加淘汰赛第三轮对战，两轮全胜直接晋级冠军赛。
          </div>
          <div class="text">
            2、星光赛区战败后，将进入火种赛区参加后续所有轮次的比赛，全胜即可晋级冠军赛。
          </div>
          <br>
          <p class="title">火种赛区说明</p>
          <div class="text">
            1、火种赛区队伍参加全部轮次的比赛，全胜即可晋级冠军赛。
          </div>
          <div class="text">
            2、火种赛区战败后，将直接淘汰，失去晋级资格。
          </div>
        `
      },
    ],
  },
  {
    id: 3,
    list: [
      {
        contentText: `
          <div class="text">
            1、冠军赛16强前，采取单局定胜负制，16强后采取三局两胜制，战胜对手后晋级。冠军赛共计6轮，通过对局确定64强、32强、16强、8强、4强、季军、亚军、冠军名额。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            2、冠军赛单场战斗最大60回合或80分钟，超出即会强制结算所有未结束的战斗。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            3、冠军赛在正式开赛还未入场的队伍默认弃权判负，对战双方全部弃权的，全部丧失比赛资格。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            4、冠军赛战败，将直接淘汰，失去参赛资格。
          </div>
        `
      },
      {
        contentText: `
          <div class="text">
            5、冠军赛每场战斗扣除10点变身信物点数。
          </div>
        `
      },
    ],
  },
];
